import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from '@/lib/auth-context';
import { Toaster } from '@/components/ui/sonner';
import { ProtectedRoute } from '@/components/protected-route';
import { Landing } from './routes/landing';
import { NotFound } from './routes/not-found';
import { TournamentsList } from './routes/tournaments';
import { TournamentNew } from './routes/tournament-new';
import { TournamentDetail } from './routes/tournament-detail';
import { PublicTournament } from './routes/public-tournament';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route
            path="/tournaments"
            element={
              <ProtectedRoute>
                <TournamentsList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tournaments/new"
            element={
              <ProtectedRoute>
                <TournamentNew />
              </ProtectedRoute>
            }
          />
          <Route
            path="/tournaments/:id"
            element={
              <ProtectedRoute>
                <TournamentDetail />
              </ProtectedRoute>
            }
          />
          <Route path="/p/:slug" element={<PublicTournament />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}
